import React from 'react';
import AboutBannerImage from '../assets/sportsday-house-banner.jpg';
import MemberImage from '../assets/director-portrait.jpg';
import MemberImage2 from '../assets/missbamidele.jpeg';
import MemberImage3 from '../assets/misstebak.png';
import studentImage from '../assets/sportsday-trophy-winners.jpg';
import '../css/AboutPageComponent.scss';
import SchoolMission from './SchooolMission';
import Values from './Values';

const AboutPageComponent = () => {
  return (
    <div >
      <section className='about-us-section '>
      <div className="slider-page-width">
      <div className="banner-container">
          <img src={AboutBannerImage} className='banner-image' alt='about-banner' />
          <div className="banner-container-overlay">About Us</div>
        </div>

      </div>
        <div className="about-us-description">
          <div className="page-width">
          <p className="about-kicker">At The Honeyrock School</p>
          <header className='about-header'>Who We Are</header>
          <p className='about-us'>
          <span className='drop-cap'>F</span>ounded in 2010 as a dedicated daycare, The Honeyrock School (THS) grew out of a simple passion: to provide children with a nurturing space to thrive. As our learners grew, we grew with them — evolving into a vibrant Preschool and expanding into a full Primary School by 2016.
         </p>

         <p>
          Today, THS is a premier educational institution in Lagos, Nigeria, trusted by families to deliver a world-class, global-standard education. We don't just teach; we lay the foundational stones for a lifetime of curiosity, character, and success.
        </p>

        <p>
          We hold ourselves to the highest standards of academic excellence and integrity. The Honeyrock School is fully approved and recognised by the Ministry of Education, proudly affiliated with the Association of Christian Schools International (ACSI) Nigeria, and an active member of the National Association of Proprietors of Private Schools (NAPPS).
        </p>

        <p className="about-promise">
          <strong>Our Promise:</strong> To give your child an outstanding foundation today, preparing them to lead and succeed in the world tomorrow.
        </p>
          </div>
        </div>
      </section>

      <SchoolMission/>
      <Values/>

      <div className="members-section">
        <div className="page-width">
          <header>Meet the Team</header>
          <div className="members-container">
            <div className="member-detail">
              <img src={MemberImage} alt='Ps. Aduke Obey' className='member-image  x'  />
              <p className="member-name">Ps. Aduke Obey</p>
              <p className="member-position">Director</p>
            </div>

            <div className="member-detail">
              <img src={MemberImage2} alt='Miss Bamidele' className='member-image y'  />
              <p className="member-name">Miss Bamidele</p>
              <p className="member-position">Head Teacher</p>
            </div>

            <div className="member-detail">
              <img src={MemberImage3} alt='Miss Tebekaemi' className='member-image z'  />
              <p className="member-name">Miss Tebekaemi</p>
              <p className="member-position">Primary Head</p>
            </div>
          </div>
        </div>
      </div>

      <div className="page-width">
        <div className="about-student">
          <div className="student-image-container">
            <img src={studentImage} alt='student' className='student-image' />
          </div>

          <div className="student-text-container">
            <header>Our Students Are</header>
            <p>
              Confident, curious, and proud of who they are. Whether they're competing on Sports Day,
              celebrating their achievements at graduation, or learning hands-on outside the classroom,
              our students bring energy and enthusiasm to everything they do.
            </p>

            <p>
              We nurture each child to discover their own strengths, work well with others, and carry
              themselves with the kind of confidence that lasts well beyond their time at HoneyRock.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPageComponent;
